module.exports = __webpack_public_path__ + "img/标题装饰@2x.a67c8e08.png";